import { apiGet } from "./client";
import type { HuntersReadModel, PortalMetrics } from "../types/api";

// GET /api/v1/hunters — see docs/API_CONTRACT.md.
export function getHunters(targetId?: string, signal?: AbortSignal) {
  const query = targetId ? `?targetId=${encodeURIComponent(targetId)}` : "";
  return apiGet<HuntersReadModel>(`/api/v1/hunters${query}`, signal);
}

// GET /api/v1/metrics
export function getMetrics(targetId?: string, signal?: AbortSignal) {
  const query = targetId ? `?targetId=${encodeURIComponent(targetId)}` : "";
  return apiGet<PortalMetrics>(`/api/v1/metrics${query}`, signal);
}
